module.exports = __webpack_public_path__ + "static/media/257.22dcc8c8.png";